import React, { useState, useEffect } from "react";
import {
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Tooltip,
  Button,
  IconButton,
} from "@mui/material";
import { MODELS_BY_SPARE_ID_LISTING_COLUMNS } from "../../utils/constant";
import RecordNotFound from "../../common/RecordNotFound";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  ModelListingBySpareIdService,
  DownloadModelsBySpareIdService,
} from "../../services/SpareSearchService";
import DownloadIcon from "@mui/icons-material/Download";
import download from "downloadjs";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";
import useGlobalState from "../../Context";

const ModelsDetail = () => {
  const [modelsBySpareId, setModelsBySpareId] = useState([]);
  const [disableDownloadButton, setDisableDownloadButton] = useState(true);
  const { id } = useParams();
  const sID = id.replace(":id", id);
  const { setLoading } = useLoading();
  const { showNotification } = useNotificationContext();
  const [{ auth }, dispatch] = useGlobalState();
  const { state } = useLocation();
  const loginParam = auth.ldapParam;
  const navigate = useNavigate();

  useEffect(() => {
    getModelBySpareId(parseInt(sID));
  }, []);

  const goBack = () => {
    if(state.fromModel){
      navigate("/model-search/model-view",{state:{modelId: state.model_id,brandName: state?.brand_name,
        modelCode: state?.model_code,}});
    }
    else{
      navigate("/spare-search");
    }
   
  };

  const getModelBySpareId = async (id) => {
    try {
      const res = await ModelListingBySpareIdService(id);
      if (res.statusCode == "6") {
        setModelsBySpareId(res.data);
      } else {
        showNotification("Error", res.message, "error");
      }
      if (res.data.length > 0) {
        setDisableDownloadButton(false);
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 8 }}>
        <Grid item xs={8} sx={{ mb: 1 }}>
        </Grid>
        <Grid
          container
          spacing={1}
          sx={{ pl: 1, pr: 3, mt: 1, mb: 0.5 }}
          display="flex"
        >
          <Grid item xs={8}>
            <Typography
              align="left"
              sx={{
                mr: "auto",
                mt: 1 / 2,
                paddingLeft: "0px",
                color: "#003f93",
                // fontWeight: "bold",
              }}
              variant="h6"   
            >
              <IconButton sx={{ color: "#003f93" }}>
                <ArrowBackIcon onClick={goBack} />
              </IconButton>{" "}
              Spare Details : {state.code}/{state.spareDescription}
            </Typography>
          </Grid>
          <Grid item xs={4} sx={{ mb: 1 }}>
            <Typography align="right">
              {loginParam.rilUser ? (
                <Tooltip title="Download Alternate Spare">
                  <Button
                    variant="contained"
                    className="button-primary-alt-contained"
                    startIcon={<DownloadIcon />}
                    sx={{ ml: 1 }}
                    disabled={disableDownloadButton}
                    onClick={async () => {
                      try {
                        setLoading(true);
                        const response = await DownloadModelsBySpareIdService(
                          sID
                        );
                        const content = response.headers["content-type"];
                        download(response.data, "ModelsDetail.csv", content);
                      } catch (err) {
                        showNotification("Error", "Failed To Fetch");
                      } finally {
                        setLoading(false);
                      }
                    }}
                  >
                    Download
                  </Button>
                </Tooltip>
              ) : null}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          containervdirection="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={12} mb={5} sx={{ pl: 1, pr: 1, mt: 2 }}>
            <Paper elevation={3} variant="elevation">
              <TableContainer sx={{ maxHeight: 720 }}>
                <Table
                  sx={{ maxHeight: 720 }}
                  aria-labelledby="tableTitle"
                  size="small"
                  className="vendorSuplierTable"
                >
                  <TableHead>
                    <TableRow key={"1"}>
                      {MODELS_BY_SPARE_ID_LISTING_COLUMNS.map((column) => (
                        <TableCell
                          className="tableHeader"
                          size="small"
                          variant="head"
                          key={column.id}
                          sx={{ pt: 1.5, pb: 1.5 }}
                          style={{
                            minWidth: column.minWidth,
                            fontWeight: "bold",
                            color: "#003A6B",
                          }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  {modelsBySpareId && modelsBySpareId.length > 0 ? (
                    <TableBody sx={{ mt: 2 }}>
                      {modelsBySpareId.map((row, index) => {
                        return (
                          <TableRow
                            tabIndex={-1}
                            hover
                            role="checkbox"
                            key={index}
                          >
                            <TableCell size="medium" key={"modelName"}>
                              {row.modelName === null ? "-" : row.modelName}
                            </TableCell>
                            <TableCell size="medium" key={"code"}>
                              {`${row["code"]}` ?? "-"}
                            </TableCell>
                            <TableCell
                              size="medium"
                              key={"modelDescription"}
                              title={
                                row.modelDescription
                                  ? row.modelDescription
                                  : "-"
                              }
                            >
                              {(row.modelDescription &&
                                row.modelDescription?.slice(0, 25)) ||
                                "-"}
                              {row.modelDescription &&
                              row.modelDescription.length > 25
                                ? "..."
                                : ""}{" "}
                            </TableCell>
                            <TableCell size="medium" key={"brandName"}>
                              {row["brandName"] ?? "-"}
                            </TableCell>
                            <TableCell size="medium" key={"brickName"}>
                              {row["brickName"] ?? "-"}
                            </TableCell>
                            <TableCell size="medium" key={"partName"}>
                              {row["partName"] ?? "-"}
                            </TableCell>
                            <TableCell size="medium" key={"defSpareActionName"}>
                              {row["defSpareActionName"] ?? "-"}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={7}>
                          <RecordNotFound />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default ModelsDetail;
